import NidApp from "./api.js";

;( function( $, nordsjo, NidApp ) {

	$( function() {

		var doingAjax = false;
		$( document.getElementById( 'nid-mp-mailinglist-form' ) ).on( 'submit', function( e ) {
			e.preventDefault();

			if ( true === doingAjax ) return;

			var $email       = $( document.getElementById( 'mailinglist-user-email' ) ),
				list_id      = $( document.getElementById( 'mailinglist-list-id' ) ).val(),
				emailAddress = $email.val(),
				action       = 'nordsjo_mailinglist_signup_user',
				data;

			if ( '' === emailAddress ) {
				NidApp.showMessage( nordsjo.emptyEmailAddress, 'error' );
				$email.focus();
				return;
			}

			NidApp.showLoadingIcon();
			doingAjax = true;

			data = {
				action: action,
				mailinglist: {
					user_email: emailAddress,
					list_id: list_id
				}
			};

			$.post( nordsjo.ajaxurl, data ).done( function( result ) {
				NidApp.removeLoadingIcon();
				doingAjax = false;

				if ( typeof result.success === 'undefined' ) return;

				var type = 'success';
				if ( true === result.success ) {
					$email.val( '' );
				} else {
					$email.focus();
					type = 'error';
				}

				NidApp.showMessage( result.data, type );
			});
		});

	});

}( jQuery, nordsjo, NidApp ));
